if(typeof source-map-support === 'undefined') {var e = new Error("Cannot find module 'source-map-support'"); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = source-map-support;